var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page mt-6 mb-6"},[_c('section',{staticClass:"container box p-0 pt-4 pb-6"},[_c('SearchBar',{on:{"change":_vm.onSearchChange}}),_c('Meldungen',{attrs:{"filter":_vm.filter}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }